import { createFileRoute } from '@tanstack/react-router'
import { DoctorSignup } from '@/features/doctor-signup'

export const Route = createFileRoute('/(auth)/doctor-signup')({
  component: DoctorSignup,
})
